"use strict";
exports.__esModule = true;
exports.GQLWeightUnit = exports.GQLUserRoleType = exports.GQLStonesPlacementType = exports.GQLSide = exports.GQLRequestType = exports.GQLPlatingType = exports.GQLPlatformProducerOrderState = exports.GQLPlatformMerchantOrderState = exports.GQLPieceSize = exports.GQLPartyType = exports.GQLMerchantDesignSampleStrategyScope = exports.GQLMerchantDeliveryType = exports.GQLMerchantChannelType = exports.GQLMaterialType = exports.GQLLanguage = exports.GQLJobType = exports.GQLJobState = exports.GQLImageSize = exports.GQLGeometryType = exports.GQLEngravingType = exports.GQLDesignerFeatureType = exports.GQLDesignSampleStrategyIteration = exports.GQLCurrency = exports.GQLCountry = exports.GQLAlignment = exports.GQLAccessoryType = exports.GQLAccessorySize = void 0;
var GQLAccessorySize;
(function (GQLAccessorySize) {
    GQLAccessorySize["Small"] = "SMALL";
    GQLAccessorySize["Medium"] = "MEDIUM";
    GQLAccessorySize["Large"] = "LARGE";
})(GQLAccessorySize = exports.GQLAccessorySize || (exports.GQLAccessorySize = {}));
var GQLAccessoryType;
(function (GQLAccessoryType) {
    GQLAccessoryType["Necklace"] = "NECKLACE";
})(GQLAccessoryType = exports.GQLAccessoryType || (exports.GQLAccessoryType = {}));
var GQLAlignment;
(function (GQLAlignment) {
    GQLAlignment["TopLeft"] = "TOP_LEFT";
    GQLAlignment["TopCenter"] = "TOP_CENTER";
    GQLAlignment["TopRight"] = "TOP_RIGHT";
    GQLAlignment["CenterLeft"] = "CENTER_LEFT";
    GQLAlignment["Center"] = "CENTER";
    GQLAlignment["CenterRight"] = "CENTER_RIGHT";
    GQLAlignment["BottomLeft"] = "BOTTOM_LEFT";
    GQLAlignment["BottomCenter"] = "BOTTOM_CENTER";
    GQLAlignment["BottomRight"] = "BOTTOM_RIGHT";
})(GQLAlignment = exports.GQLAlignment || (exports.GQLAlignment = {}));
var GQLCountry;
(function (GQLCountry) {
    GQLCountry["China"] = "CHINA";
    GQLCountry["Netherlands"] = "NETHERLANDS";
    GQLCountry["UnitedStates"] = "UNITED_STATES";
})(GQLCountry = exports.GQLCountry || (exports.GQLCountry = {}));
var GQLCurrency;
(function (GQLCurrency) {
    GQLCurrency["Eur"] = "EUR";
    GQLCurrency["Usd"] = "USD";
})(GQLCurrency = exports.GQLCurrency || (exports.GQLCurrency = {}));
var GQLDesignSampleStrategyIteration;
(function (GQLDesignSampleStrategyIteration) {
    GQLDesignSampleStrategyIteration["Sequential"] = "SEQUENTIAL";
})(GQLDesignSampleStrategyIteration = exports.GQLDesignSampleStrategyIteration || (exports.GQLDesignSampleStrategyIteration = {}));
var GQLDesignerFeatureType;
(function (GQLDesignerFeatureType) {
    GQLDesignerFeatureType["Text"] = "TEXT";
    GQLDesignerFeatureType["SingleLetter"] = "SINGLE_LETTER";
    GQLDesignerFeatureType["Symbol"] = "SYMBOL";
})(GQLDesignerFeatureType = exports.GQLDesignerFeatureType || (exports.GQLDesignerFeatureType = {}));
var GQLEngravingType;
(function (GQLEngravingType) {
    GQLEngravingType["Symbol"] = "SYMBOL";
    GQLEngravingType["SingleLetter"] = "SINGLE_LETTER";
    GQLEngravingType["Text"] = "TEXT";
    GQLEngravingType["Vector"] = "VECTOR";
    GQLEngravingType["Bitmap"] = "BITMAP";
    GQLEngravingType["None"] = "NONE";
})(GQLEngravingType = exports.GQLEngravingType || (exports.GQLEngravingType = {}));
var GQLGeometryType;
(function (GQLGeometryType) {
    GQLGeometryType["Cross"] = "CROSS";
    GQLGeometryType["HalfMoon"] = "HALF_MOON";
    GQLGeometryType["Heart"] = "HEART";
    GQLGeometryType["Oval"] = "OVAL";
    GQLGeometryType["Round"] = "ROUND";
    GQLGeometryType["Rectangular"] = "RECTANGULAR";
    GQLGeometryType["Square"] = "SQUARE";
    GQLGeometryType["StarFive"] = "STAR_FIVE";
    GQLGeometryType["Sun"] = "SUN";
    GQLGeometryType["Teardrop"] = "TEARDROP";
    GQLGeometryType["Triangle"] = "TRIANGLE";
    GQLGeometryType["Other"] = "OTHER";
})(GQLGeometryType = exports.GQLGeometryType || (exports.GQLGeometryType = {}));
var GQLImageSize;
(function (GQLImageSize) {
    GQLImageSize["Small"] = "SMALL";
    GQLImageSize["Medium"] = "MEDIUM";
    GQLImageSize["Large"] = "LARGE";
})(GQLImageSize = exports.GQLImageSize || (exports.GQLImageSize = {}));
var GQLJobState;
(function (GQLJobState) {
    GQLJobState["Created"] = "CREATED";
    GQLJobState["Started"] = "STARTED";
    GQLJobState["FinishedSuccess"] = "FINISHED_SUCCESS";
    GQLJobState["FinishedFailed"] = "FINISHED_FAILED";
})(GQLJobState = exports.GQLJobState || (exports.GQLJobState = {}));
var GQLJobType;
(function (GQLJobType) {
    GQLJobType["OrdersSyncShopToPlatform"] = "ORDERS_SYNC_SHOP_TO_PLATFORM";
    GQLJobType["OrdersSyncPlatformToShop"] = "ORDERS_SYNC_PLATFORM_TO_SHOP";
    GQLJobType["MerchantCatalogSyncPlatformToShop"] = "MERCHANT_CATALOG_SYNC_PLATFORM_TO_SHOP";
    GQLJobType["MerchantShopResetState"] = "MERCHANT_SHOP_RESET_STATE";
    GQLJobType["AccessoryCadModelImport"] = "ACCESSORY_CAD_MODEL_IMPORT";
    GQLJobType["PieceCadModelImport"] = "PIECE_CAD_MODEL_IMPORT";
    GQLJobType["AccessoryImagesGenerate"] = "ACCESSORY_IMAGES_GENERATE";
    GQLJobType["PieceImagesGenerate"] = "PIECE_IMAGES_GENERATE";
    GQLJobType["MerchantCatalogImagesGenerate"] = "MERCHANT_CATALOG_IMAGES_GENERATE";
})(GQLJobType = exports.GQLJobType || (exports.GQLJobType = {}));
var GQLLanguage;
(function (GQLLanguage) {
    GQLLanguage["English"] = "ENGLISH";
})(GQLLanguage = exports.GQLLanguage || (exports.GQLLanguage = {}));
var GQLMaterialType;
(function (GQLMaterialType) {
    GQLMaterialType["Silver"] = "SILVER";
})(GQLMaterialType = exports.GQLMaterialType || (exports.GQLMaterialType = {}));
var GQLMerchantChannelType;
(function (GQLMerchantChannelType) {
    GQLMerchantChannelType["Magento"] = "MAGENTO";
    GQLMerchantChannelType["Shopify"] = "SHOPIFY";
    GQLMerchantChannelType["WooCommerce"] = "WOO_COMMERCE";
    GQLMerchantChannelType["Jewelutions"] = "JEWELUTIONS";
})(GQLMerchantChannelType = exports.GQLMerchantChannelType || (exports.GQLMerchantChannelType = {}));
var GQLMerchantDeliveryType;
(function (GQLMerchantDeliveryType) {
    GQLMerchantDeliveryType["Warehouse"] = "WAREHOUSE";
    GQLMerchantDeliveryType["Dropship"] = "DROPSHIP";
})(GQLMerchantDeliveryType = exports.GQLMerchantDeliveryType || (exports.GQLMerchantDeliveryType = {}));
var GQLMerchantDesignSampleStrategyScope;
(function (GQLMerchantDesignSampleStrategyScope) {
    GQLMerchantDesignSampleStrategyScope["Piece"] = "PIECE";
})(GQLMerchantDesignSampleStrategyScope = exports.GQLMerchantDesignSampleStrategyScope || (exports.GQLMerchantDesignSampleStrategyScope = {}));
var GQLPartyType;
(function (GQLPartyType) {
    GQLPartyType["Merchant"] = "MERCHANT";
    GQLPartyType["Producer"] = "PRODUCER";
    GQLPartyType["Platform"] = "PLATFORM";
})(GQLPartyType = exports.GQLPartyType || (exports.GQLPartyType = {}));
var GQLPieceSize;
(function (GQLPieceSize) {
    GQLPieceSize["Small"] = "SMALL";
    GQLPieceSize["Medium"] = "MEDIUM";
    GQLPieceSize["Large"] = "LARGE";
})(GQLPieceSize = exports.GQLPieceSize || (exports.GQLPieceSize = {}));
var GQLPlatformMerchantOrderState;
(function (GQLPlatformMerchantOrderState) {
    GQLPlatformMerchantOrderState["New"] = "NEW";
    GQLPlatformMerchantOrderState["InProduction"] = "IN_PRODUCTION";
    GQLPlatformMerchantOrderState["Shipped"] = "SHIPPED";
    GQLPlatformMerchantOrderState["Canceled"] = "CANCELED";
    GQLPlatformMerchantOrderState["Rejected"] = "REJECTED";
    GQLPlatformMerchantOrderState["Completed"] = "COMPLETED";
})(GQLPlatformMerchantOrderState = exports.GQLPlatformMerchantOrderState || (exports.GQLPlatformMerchantOrderState = {}));
var GQLPlatformProducerOrderState;
(function (GQLPlatformProducerOrderState) {
    GQLPlatformProducerOrderState["New"] = "NEW";
    GQLPlatformProducerOrderState["InProduction"] = "IN_PRODUCTION";
    GQLPlatformProducerOrderState["Shipped"] = "SHIPPED";
    GQLPlatformProducerOrderState["Canceled"] = "CANCELED";
    GQLPlatformProducerOrderState["Rejected"] = "REJECTED";
    GQLPlatformProducerOrderState["Completed"] = "COMPLETED";
})(GQLPlatformProducerOrderState = exports.GQLPlatformProducerOrderState || (exports.GQLPlatformProducerOrderState = {}));
var GQLPlatingType;
(function (GQLPlatingType) {
    GQLPlatingType["Rhodium"] = "RHODIUM";
    GQLPlatingType["YellowGold"] = "YELLOW_GOLD";
    GQLPlatingType["RoseGold"] = "ROSE_GOLD";
})(GQLPlatingType = exports.GQLPlatingType || (exports.GQLPlatingType = {}));
var GQLRequestType;
(function (GQLRequestType) {
    GQLRequestType["PlatformProducerContractChange"] = "PLATFORM_PRODUCER_CONTRACT_CHANGE";
    GQLRequestType["PlatformMerchantContractChange"] = "PLATFORM_MERCHANT_CONTRACT_CHANGE";
})(GQLRequestType = exports.GQLRequestType || (exports.GQLRequestType = {}));
var GQLSide;
(function (GQLSide) {
    GQLSide["Front"] = "FRONT";
    GQLSide["Back"] = "BACK";
})(GQLSide = exports.GQLSide || (exports.GQLSide = {}));
var GQLStonesPlacementType;
(function (GQLStonesPlacementType) {
    GQLStonesPlacementType["NoStones"] = "NO_STONES";
    GQLStonesPlacementType["FullStones"] = "FULL_STONES";
})(GQLStonesPlacementType = exports.GQLStonesPlacementType || (exports.GQLStonesPlacementType = {}));
var GQLUserRoleType;
(function (GQLUserRoleType) {
    GQLUserRoleType["Admin"] = "ADMIN";
})(GQLUserRoleType = exports.GQLUserRoleType || (exports.GQLUserRoleType = {}));
var GQLWeightUnit;
(function (GQLWeightUnit) {
    GQLWeightUnit["Grams"] = "GRAMS";
    GQLWeightUnit["Kilograms"] = "KILOGRAMS";
    GQLWeightUnit["Ounces"] = "OUNCES";
    GQLWeightUnit["Pounds"] = "POUNDS";
})(GQLWeightUnit = exports.GQLWeightUnit || (exports.GQLWeightUnit = {}));
